import { hasClaim } from '../auth/authHelpers';
import bus from '../connection/storeManagerConnection';
import store from '../store';
import endpoint from '../util/endpoint';
import { updateProduct } from '@/product/product.action';
import { ConnectionStatus } from '@whiz-cart/node-shared/connection/connection';
import genGuid from '@whiz-cart/node-shared/guid';
import { MhdItem } from '@whiz-cart/node-shared/models/mhd/mhdItem';
// @ts-expect-error missing types
import { SwSync } from '@whiz-cart/ui-shared/sync/swSync.js';
// @ts-expect-error missing types
import { Sync } from '@whiz-cart/ui-shared/sync/sync.js';
import _ from 'lodash';

const deviceId = genGuid();
const swSync = new SwSync('mhd');

let cancel: (() => void) | undefined;

const transformIncoming = <T extends (any | undefined)[]>(...items: T): { [K in keyof T]: any } => {
    const productsUi: any[] = [];

    const transformed = items.map(({ barcode, expireOn, amount, updatedOn, updatedBy, productUi, mhdGroup, unknownProduct }) => {
        if (productUi) {
            productsUi.push({ ...productUi, mhdGroup });
        }
        return {
            id: `${bus.config.storeGuid}:${barcode}`,
            storeGuid: bus.config.storeGuid,
            barcode,
            expireOn,
            amount,
            updatedOn,
            updatedBy,
            mhdGroup: unknownProduct ? unknownProduct.mhdGroup : mhdGroup,
        };
    }) as { [K in keyof T]: any };

    if (productsUi.length) {
        store.dispatch(updateProduct(...productsUi));
    }

    return transformed;
};

const transformOutgoing = ({ barcode, expireOn, amount }: MhdItem) => ({
    storeGuid: bus.config.storeGuid,
    barcode,
    expireOn,
    amount,
    updatedBy: deviceId,
});

const on = (messageListener: (item: any) => void, reconnectListener: () => void) => {
    const cancelMessageListener = bus.subscribe('productExpirationUpdate', (item) => {
        // TODO: parse item
        messageListener(transformIncoming(item)[0]);
    });
    const cancelStatusListener = bus.subscribeStatus((status) => status === ConnectionStatus.Connected && reconnectListener());
    cancel = () => {
        cancelMessageListener();
        cancelStatusListener();
    };
};
const off = () => cancel?.();
const get = async () => {
    if (!bus.config.storeGuid) return [];

    if (!hasClaim()('product/expiration/read', 'store', bus.config.storeGuid)) return [];

    const maxDate =
        _(store.getState().mhd.items)
            .values()
            .filter((item) => item.storeGuid === bus.config.storeGuid)
            .map((item) => new Date(item.updatedOn))
            .max() || new Date(0);

    return endpoint('storeManager.getMHDList', { storeGuid: bus.config.storeGuid })
        .post({ from: maxDate.toISOString() })
        .then((items: any) => transformIncoming(...items));
};
const update = (item: MhdItem) => swSync.queue(transformOutgoing(item));

export default new Sync({
    name: 'mhd',
    connection: { on, off, get, update },
    dispatch: (...args: any[]) => (store.dispatch as any)(...args),
    deviceId: () => deviceId,
});
